import PhioengageService, { ServiceResponse } from 'services/PhioengageService';

export interface SelfManagementPayload {
    email: string;
    first_name: string;
    last_name: string;
    region: string;
    postcode?: string;
    programme_id: string;
    date_of_birth?: string;
    [key: string]: any; // Allows for additional properties to be included in the payload
}

/**
 * Approves a user for a programme on engage
 * @remarks - This function is used to approve a user for a programme on engage under version 2
 * @param {SelfManagementPayload} payload
 * @returns {Promise<unknown>}
 */
const approveForSelfManagement = async (payload: SelfManagementPayload): Promise<unknown> => {
    const service = new PhioengageService<SelfManagementPayload, ServiceResponse>();
    const resp = await service.invoke(payload, 'phioengage-profile-approve');
    return resp;
};

export default approveForSelfManagement;
